import { render, staticRenderFns } from "./PbStatistics.vue?vue&type=template&id=1ad56959&"
import script from "./PbStatistics.js?vue&type=script&lang=js&"
export * from "./PbStatistics.js?vue&type=script&lang=js&"
import style0 from "./PbStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports